<template>
	<div id="CommentsComponent">  
		<div v-if="showMediaManager">
			<media-manager
				:picsInGallery="[]"
				:maxItemSelected="1"
				@receiveMedias="addPictures($event)"
				@closeTabs="closeTabs()"
			/>
		</div>

		<draggable
			:force-fallback="true"
			v-model="activeTestimonials"
			v-bind="{ draggable: '.comment-item', handle: '.move-item' }"
			@end="updateOrderComments"
		>
			<div
        		v-for="(comment, index) in activeTestimonials"
        		:key="comment.frameDataId"
        		class="comment-item"
		      >
        		<CommentCard
          			:comment="comment"
          			:editable="editable"
          			@editThisItem="handleTestimony(index)"
          			@removeComment="deleteTestimonial(index)"
        		/>
        		<hr />
      		</div>
    	</draggable>
    	<div class="row m-0">
      		<div class="col-12 text-center">
        		<button class="btn btn-primario button-new-comment" @click="handleTestimonyManager">Novo depoimento</button>
      		</div>
		</div>
    	<div v-if="editTestimony.show == true" class="testimony-editor">
      		<div class="card">
        		<div class="card-body">
          			<div class="row align-items-center">
            			<div class="col-auto">
              				<label @click="() => {showMediaManager = true}" class="testimony-label" for="updateAvatar" v-if="!loadingAvatar">
								<img
									v-if="editTestimony.element.picture"
									:src="concatenateImageUrl(editTestimony.element.picture)"
									alt=""
									class="rounded-circle edit-testimony-picture pointer"
								/>
								<span v-else class="picture-label pointer">
                  					<i class="fal fa-camera"></i>
								</span>
              				</label>
              				<span v-else class="picture-label">
                				<i class="fal fa-spinner fa-spin"></i>
              				</span>
						</div>
            			<div class="col">
							<label class="testimony-label" for="editableName">Nome</label>
							<input
								id="editableName"
								class="form-control input-title-testimony"
								placeholder="Nome"
								v-model="editTestimony.element.name"
								type="text"
							/>
						</div>
						<div class="col-12 mt-3">
							<label class="testimony-label" for="editableText">Depoimento</label>
								<TinyEditor
									:frameType="'text'"
									:textContent="editTestimony.element.text"	
									@contentText="checkToConvert($event, editTestimony.element.text)"
									:inline="false"
								></TinyEditor>
						</div>
						<div class="col-3  mt-3">
							<label class="testimony-label" for="editableButtonText">Texto do botão</label>
							<input id="editableButtonText" class="form-control" type="text"  placeholder="Texto do botão" v-model="editTestimony.element.buttonText">
						</div>
						<div class="col-3  mt-3">
							<label class="testimony-label" for="editableTargetType">Abrir em</label>
							<select id="editableTargetType" class="form-control" v-model="editTestimony.element.target">
								<option selected value="_blank">Nova aba</option>
								<option value="_self">Mesma aba</option>
							</select>
						</div>
						<div class="col-6  mt-3">
							<label class="testimony-label" for="editableUrl">Link</label>
							<input id="editableUrl" class="form-control" type="text" placeholder="Link" v-model="editTestimony.element.url">
						</div>
						<div class="col-12 mt-3">
							<p class="mb-2 error-message" v-for="(error, index) in editTestimony.errors" :key="index">
								<small>{{ error }}</small>
							</p>
						</div>
          			</div>
					<div class="row justify-content-between mt-3">
						<div class="col-auto">
							<div class="btn btn-secundario py-2" @click="cancelEditTestimony()">
								Cancelar
							</div>
						</div>
						<div class="col-auto">
							<div class="btn btn-primario py-2" @click="editTestimonial()">
								Adicionar
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-show="testimonyManager.show" class="testimony-manager">
      		<div class="row">
				<div class="col-12 pb-4">
          			<span @click="testimonyManager.show = false" class="pointer"><i class="fal fa-chevron-down"></i></span>
        		</div>
        		<div class="col-12">
          			<masonry :cols="{ default: 5, 1024: 4, 700: 1 }" :gutter="8">
						<div
							class="mt-2 mb-3 create-testimony-button text-center card pointer"
							@click="createNewTestimony()"
							ref="newTestimonyButton"
						>
							<h2 class="mb-0"><i class="far fa-comment"></i></h2>
							<span>Criar depoimento</span>
						</div>
						<div
							class="my-2"
							v-for="(testimony, index) in listTestimonials"
							@click="testimony.save_comment = !testimony.save_comment"
							:key="index"
						>
							<Testimony :comment="testimony" />
						</div>
          			</masonry>
				</div>
				<div class="container-button">
					<button class="btn btn-primario" id="mediaManagerButton" :disabled="validateButton" @click="importNewTestimonials()">
						Adicionar
					</button>
				</div>
      		</div>
    	</div>
  	</div>
</template>

<script>
import TinyEditor from "@/components/organisms/TinyEditor.vue"
import apiMixins from "@/mixins/apiMixins";
import Testimony from "@/components/Testimony";
import CommentCard from "@/components/blocks/CommentCard.vue";
import draggable from "vuedraggable";
import axios from "axios";
import MediaManager from '../organisms/MediaManager.vue';

export default {
	name: "CommentsComponent",
  	mixins: [apiMixins],
	data() {
    	return {
			showMediaManager: false,
      		editTestimony: {
        		show: false,
				index: null,
        		element: {
          			picture: "",
          			name: "",
          			text: "",
          			save_comment: 1,
          			score: 0,
					source: "Uli",
					target: '_blank',
					url: '',
					buttonText: ''
        		},
        		errors: []
      		},
      		testimonyManager: {
        		show: false,
        		loaded: false,
        		testimonies: []
      		},
      		newCommentName: "",
      		newCommentText: "",
			newCommentPicture: "",
      		activeTestimonials: [],
      		listTestimonials: [],
      		file: "",
      		loadingAvatar: false,
			testimonyEmpty: false,
    	};
  	},
  	props: {
    	comments: {
      		required: false,
					default: [],
		},
		editable: {
      		type: Boolean
    	},
    	frameId: {
      		type: Number
    	}
  	},
	components: {
	    CommentCard,
    	draggable,
    	Testimony,
		TinyEditor,
		MediaManager
	},
	created() {
    	this.activeTestimonials = [...this.comments];
    	this.getTestimonialsList();
	},
  	methods: {
		addPictures(picture) {
			this.editTestimony.element.picture = picture[0].url;

			this.showMediaManager = false;
		},
		closeTabs() {
			this.showMediaManager = false;
		},	
		checkToConvert(text, item) {
			this.editTestimony.element.text = text;
			if (text.split(" ").length === 1) {
				text = text.replace(/\<a\>|\<\/a>|\<p\>|\<\/p\>|\<br\>/g, "");
				const matchesVideo = text.match(
					/^((https:|http:)\/\/){0,1}w{0,3}\.{0,1}(youtu|vimeo\.com\/\d+).+$/gm
				);
				const matchesMusic = text.match(
					/(https:\/\/){0,1}(open\.spotify\.com)\/(track|playlist|album|show|user|artist|episode)|soundcloud\.com\/.+/gm
				);

				if (matchesVideo !== null || matchesMusic !== null) {
					if (matchesVideo !== null) {
						this.$emit("changeTextToVideo", text);
						return true;
					} else if (matchesMusic !== null) {
						this.$emit("changeTextToMusic", text);
						return true;
					}
				}
				return false;
			}
		},
		async getTestimonialsList(){
			const url = `/site/${localStorage.siteId}/wizard/comments`;
			const responseData = await this.requestApiData(url, "get");
			this.listTestimonials = responseData.data;
		},
		createNewTestimony(){
			const newTestimony = this.testimonyFactory();
			this.activeTestimonials.push(newTestimony)
			this.testimonyEmpty = true;
			this.toggleTestimonialsList();
			this.handleTestimony(this.activeTestimonials.length - 1);
		},
		testimonyFactory(element = null){
			let testimonyFrame = {
				frameId: this.generateTempId(),
				frameDataId:null,
				frameType:'comment',
				frameStatus:1,
				component:null,
				extra:null,
				grid:12,
				frameOrigin:null,
				action:null,
				actionType:null,
				subPagesCategories:[],
				frameContent:{
					save_comment: 1,
					source:'Uli',
					datetime: this.getDateNow(),
					name:'',
					text:'',
					score:0,
					lenght:11,
					picture: null
				}
			}
			if(element != null){
				testimonyFrame.frameContent = {...testimonyFrame.frameContent, ...element}
			}
			return testimonyFrame
		},
		importNewTestimonials(){
			const testimonialsToSave = this.listTestimonials.filter(
				testimony => testimony.save_comment == true
			);
			testimonialsToSave.forEach(element => {
				const newTestimony = this.testimonyFactory(element)
				this.activeTestimonials.push(newTestimony);
			});
			this.listTestimonials = this.listTestimonials.map(testimony =>
				testimony.save_comment == true
				? { ...testimony, save_comment: false }
				: testimony
			);
			this.testimonyManager.show = false;
			this.updateOrderComments();
		},
		handleTestimony(index){
			this.editTestimony.element = { ...this.activeTestimonials[index].frameContent };
			this.editTestimony.index = index;
			this.editTestimony.show = true;
		},
		editTestimonial(){
			this.editTestimony.errors = [];
			const index = this.editTestimony.index;
			const testimony = this.editTestimony.element;
			this.editTestimony.errors = this.validateTestimonyToSave(testimony)
			if(this.editTestimony.errors.length == 0){
				this.activeTestimonials[index].frameContent = testimony;
				this.testimonyManager.show = false;
				this.clearEditTestimony();
				this.$emit("updateOrderComments", this.activeTestimonials);
				this.testimonyEmpty = false;
			}
		},
		deleteTestimonial(index){
			this.activeTestimonials.splice(index, 1);
		},
		updateStore(){

		},
		async uploadAvatar(){

		},
		validateTestimonyToSave(testimony){
			let errors = [];
			if (!testimony.name) {
				errors.push("Nome obrigatório");
			}
			if (!testimony.text) {
				errors.push("Texto obrigatório");
			}
			return errors;
		},
		generateTempId(){
			const date = new Date();
			let dateTime = date.getTime();
			let isInvalidId = this.validateTempId(dateTime)
			if(isInvalidId){
				dateTime = dateTime + 1;
			}
			return `temp-${dateTime}`;
		},
		validateTempId(dateTime){
			return this.activeTestimonials.some(testimony => testimony.frameId == `temp-${dateTime}`)	
		},
		getDateNow() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1;
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = "0" + dd;
			}
			if (mm < 10) {
				mm = "0" + mm;
			}
			today = `${dd}/${mm}/${yyyy}`;
			return today;
		},
		toggleTestimonialsList(){
			this.testimonyManager.show = !this.testimonyManager.show;
		},
		handleUploadAvatar,
		handleFileUpload,
		editThisItem,
		updateOrderComments,
		cancelEditTestimony,
		updateTestimony,
		clearEditTestimony,
		concatenateImageUrl,
		handleTestimonyManager
  	},
  	computed: {
    	validateButton() {
      		return !this.listTestimonials.some(
        		testimony => testimony.save_comment == true
      		);
    	},
		manageComments() {
      		return this.comments.filter(comment => comment.frameStatus == 1);
    	},
		avatarNewComment() {
      		if (!this.newCommentPicture) {
        		return "/static/img/default-user.png";
      		} else {
        		return process.env.CDN_URL + this.newCommentPicture;
      		}
		}
	  },
	watch:{
		activeTestimonials(){
			this.$emit("updateOrderComments", this.activeTestimonials);
		}
	}
  	
};
function handleTestimonyManager(){
	this.testimonyManager.show = true
	if(this.listTestimonials.length === 0){
		this.$refs.newTestimonyButton.click();
	}
}
function concatenateImageUrl(image) {
  	return `${process.env.CDN_URL}${image}`;
}
function clearEditTestimony() {
	this.editTestimony.show = false;
	this.editTestimony.index = "";
	this.editTestimony.element = {
		picture: "",
		name: "",
		text: "",
		save_comment: 1,
		score: 0,
		source: "Uli"
	};
	this.editTestimony.errors = [];
}
function updateTestimony(testimony, index) {
  	// this.activeTestimonials[index].frameContent = testimony;
}
function editThisItem(index) {
	this.editTestimony.element = { ...this.activeTestimonials[index].frameContent };
	this.editTestimony.index = index;
	this.editTestimony.show = true;
}
function cancelEditTestimony() {
	this.editTestimony.show = false;
	this.editTestimony.errors = [];
	this.editTestimony.element = {
		picture: "",
		name: "",
		text: "",
		save_comment: 1,
		score: 0,
		source: "Uli"
	}
	if(this.testimonyEmpty){this.activeTestimonials.pop()};
	this.testimonyEmpty = false;
}
function handleUploadAvatar() {
  	document.getElementById("newAvatarComment").click();
}
function handleFileUpload() {
	this.loadingAvatar = true;
	this.file = this.$refs.file.files[0];
	let str = this.file.name.toLowerCase().split(".");
	let siteId = this.$session.get("siteId");
	if (
		str[str.length - 1] == "jpeg" ||
		str[str.length - 1] == "jpg" ||
		str[str.length - 1] == "png"
	) {
		let siteId = this.$session.get("siteId");
		let token = this.$session.get("jwt");
		let formData = new FormData();
		formData.append("siteId", siteId);
		formData.append("images[]", this.file);
		axios({
		method: "post",
		url: `${process.env.ROOT_API}api/site/${siteId}/image/upload`,
		data: formData,
		headers: {
			Authorization: "Bearer " + token
		}
		})
		.then(response => {
			if (response.data.status == 1) {
			this.editTestimony.element.picture = response.data.url;
			}
		})
		.catch(response => {
			alert("Erro ao alterar imagem");
			console.log(response);
		});
	} else {
		alert("Formato incompatível");
	}
	setTimeout(() => {
		this.loadingAvatar = false;
	}, 5000);
}
function updateOrderComments() {
  	this.$emit("updateOrderComments", this.activeTestimonials);
}
</script>

<style scoped>
	.testimony-label{
		color: rgba(0, 0, 0, 0.32);
		font-weight: 700;
		font-size: 0.6rem;
	}
	.create-testimony-button{
		background: #F2F2F2;
		color: #858585;
		font-weight: 700;
		font-size: 1.3rem;
		min-height: 140px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.input-title-testimony {
		font-size: 1.2em;
		line-height: 1.5;
		font-weight: 700;
	}
	.edit-testimony-picture {
		width: 60px;
		height: 60px;
		object-fit: cover;
	}
	.picture-label {
		background-color: #eee;
		width: 60px;
		height: 60px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 1.5rem;
	}
	.container-button {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 20px 10px;
		display: flex;
		justify-content: center;
		align-content: center;
	}
	.testimony-editor {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: #fff;
		z-index: 9999;
		overflow-y: hidden;
		overflow-x: hidden;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
	.testimony-editor .card {
		width: 800px;
		padding: 16px;
	}
	@media all and (max-width: 998px) {
		.testimony-editor .card {
			width: 600px;
		}
	}
	@media all and (max-width: 500px) {
			.testimony-editor .card {
				width: 300px;
			}
	}
	.testimony-manager {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: #fff;
		z-index: 10;
		padding: 10px;
		overflow-y: auto;
		overflow-x: hidden;
	}
	.total-avatar:hover {
		cursor: pointer;
	}
	.avatar-comment {
		width: 60px;
		height: 60px;
		display: inline-block;
		margin-right: 10px;
		margin-bottom: 18px;
		object-fit: cover;
	}
	.fakeMedium {
		border-bottom: none !important;
		width: 100%;
	}
	hr {
		margin-top: 22px;
		margin-bottom: 22px;
	}
	.button-new-comment:hover {
		cursor: pointer;
	}
	.add-comment {
		color: #777;
	}
	.add-comment:hover {
		cursor: pointer;
		color: var(--main-color);
	}
</style>



// WEBPACK FOOTER //
// src/components/blocks/CommentsComponent.vue